module.exports = __webpack_public_path__ + "static/media/overpass2.79b65d1b.jpg";